import { useState } from 'react';
import type { SaveTableRequest, TableAdminDTO } from '@six-pockets/shared';
import { MoneyInput, TextField } from '@/components/ui';
import { parseWhole } from '../draft';
import { FormRow, ManageFormModal } from './ManageFormModal';

interface TableFormModalProps {
  /** Null to add a new table. */
  table: TableAdminDTO | null;
  busy: boolean;
  error: string | null;
  onSave: (body: SaveTableRequest) => void;
  onClose: () => void;
}

/** Add or edit a table. Mount it only while open (with a key per table) so the fields start fresh. */
export function TableFormModal({ table, busy, error, onSave, onClose }: TableFormModalProps) {
  const [name, setName] = useState(table?.name ?? '');
  const [kind, setKind] = useState(table?.kind ?? '');
  const [rate, setRate] = useState(table ? String(table.ratePerHour) : '');
  const [order, setOrder] = useState(table ? String(table.sortOrder) : '');

  const ratePerHour = parseWhole(rate);
  const sortOrder = order.trim() ? parseWhole(order) : undefined;
  const blocked = !name.trim()
    ? 'Enter a name'
    : !kind.trim()
      ? 'Enter the table type'
      : ratePerHour === null
        ? 'Enter the rate per hour in whole rupees'
        : sortOrder === null
          ? 'Display order must be a whole number'
          : undefined;

  const submit = () =>
    onSave({ name: name.trim(), kind: kind.trim(), ratePerHour: ratePerHour!, ...(sortOrder !== undefined && { sortOrder: sortOrder! }) });

  return (
    <ManageFormModal
      title={table ? `Edit ${table.name}` : 'Add table'}
      submitLabel={table ? 'Save changes' : 'Add table'}
      busy={busy}
      error={error}
      blockedReason={blocked}
      onSubmit={submit}
      onClose={onClose}
    >
      <TextField label="Name" placeholder="Table 3" value={name} onChange={(e) => setName(e.target.value)} maxLength={40} data-autofocus />
      <TextField label="Type" placeholder="English Snooker" value={kind} onChange={(e) => setKind(e.target.value)} maxLength={40} />
      <FormRow>
        <MoneyInput label="Rate per hour" value={rate} onChange={setRate} />
        <TextField
          label="Display order"
          type="number"
          inputMode="numeric"
          min={0}
          step={1}
          mono
          placeholder={table ? '' : 'Last'}
          value={order}
          onChange={(e) => setOrder(e.target.value)}
        />
      </FormRow>
    </ManageFormModal>
  );
}
